import { Module } from 'vuex'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'

interface JudgeState {
  judgeId: string
  isTestLoading: boolean
  isJudgeLoading: boolean
  isTestNotificationLoading: boolean
  isJudgeNotificationLoading: boolean
  judgeRecord: JudgeRecord | null
  testInput: string
  testOutput: string
}

export const judgeStateModule = (): Module<JudgeState, any> => {
  return {
    namespaced: true,
    state: {
      judgeId: '',
      isTestLoading: false,
      isJudgeLoading: false,
      isTestNotificationLoading: false,
      isJudgeNotificationLoading: false,
      judgeRecord: null,
      testInput: '',
      testOutput: 'Hello World\n'
    },
    mutations: {
      setJudgeId(state, judgeId: string) {
        state.judgeId = judgeId
      },
      setIsTestLoading(state, isLoading: boolean) {
        state.isTestLoading = isLoading
      },
      setIsJudgeLoading(state, isLoading: boolean) {
        state.isJudgeLoading = isLoading
      },
      setIsTestNotificationLoading(state, isLoading: boolean) {
        state.isTestNotificationLoading = isLoading
      },
      setIsJudgeNotificationLoading(state, isLoading: boolean) {
        state.isJudgeNotificationLoading = isLoading
      },
      setJudgeRecord(state, judgeRecord: JudgeRecord | null) {
        state.judgeRecord = judgeRecord
      },
      setTestInput(state, input: string) {
        state.testInput = input
      },
      setTestOutput(state, output: string) {
        state.testOutput = output
      }
    },
    actions: {},
    getters: {
      judgeId: state => state.judgeId,
      isTestLoading: state => state.isTestLoading,
      isJudgeLoading: state => state.isJudgeLoading,
      isTestNotificationLoading: state => state.isTestNotificationLoading,
      isJudgeNotificationLoading: state => state.isJudgeNotificationLoading,
      judgeRecord: state => state.judgeRecord,
      testInput: state => state.testInput,
      testOutput: state => state.testOutput
    }
  }
}
